var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", {
        attrs: { subtitle: "Manage media types across the system." },
      }),
      _vm._v(" "),
      _c(
        "Subheader",
        {
          attrs: { title: "Media Types", search: "media types" },
          model: {
            value: _vm.search,
            callback: function ($$v) {
              _vm.search = $$v
            },
            expression: "search",
          },
        },
        [
          _c(
            "v-btn",
            {
              attrs: { color: "success" },
              on: {
                click: function ($event) {
                  _vm.showAddType = true
                },
              },
            },
            [
              _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("Button.Add_a_new_Media_Type")) +
                  "\n    "
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.MediaTypeList,
                  pagination: _vm.pagination,
                  search: _vm.search,
                },
                on: {
                  "update:pagination": function ($event) {
                    _vm.pagination = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function (props) {
                      return [
                        _c(
                          "td",
                          [
                            _c("v-icon", { staticClass: "mr-1" }, [
                              _vm._v(_vm._s(props.item.IconPath)),
                            ]),
                            _vm._v(
                              "\n            " +
                                _vm._s(props.item.Name) +
                                "\n          "
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(props.item.IconPath))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(props.item.TenantName))]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-right" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { small: "", depressed: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.clickEditType(props.item)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("Button.Manage_Type")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  small: "",
                                  depressed: "",
                                  color: "error",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.clickRemove(props.item)
                                  },
                                },
                              },
                              [
                                _c("v-icon", [_vm._v("delete_forever")]),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("Button.Remove")) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800px" },
          model: {
            value: _vm.showAddType,
            callback: function ($$v) {
              _vm.showAddType = $$v
            },
            expression: "showAddType",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("AdministrationMediaTypeManage.addTitleMsg")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      nativeOn: {
                        click: function ($event) {
                          _vm.showAddType = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "fullScreenWidth",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function ($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid",
                  },
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", "pa-3": "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Media Type Name",
                                  rules: _vm.nameRules,
                                },
                                model: {
                                  value: _vm.newMediaType.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newMediaType, "name", $$v)
                                  },
                                  expression: "newMediaType.name",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: {
                                  label: "Icon Path",
                                  items: _vm.iconList,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "v-avatar",
                                          [
                                            _c("v-icon", [
                                              _vm._v(_vm._s(data.item)),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(data.item) +
                                            "\n                "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "v-list-tile-avatar",
                                          [
                                            _c("v-icon", [
                                              _vm._v(_vm._s(data.item)),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-list-tile-content", [
                                          _vm._v(_vm._s(data.item)),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                                model: {
                                  value: _vm.newMediaType.IconPath,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newMediaType, "IconPath", $$v)
                                  },
                                  expression: "newMediaType.IconPath",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-combobox", {
                                attrs: {
                                  label: "Tenant",
                                  items: _vm.allRoleList,
                                  "item-text": "RoleName",
                                  "item-value": "Id",
                                  rules: _vm.tenantRules,
                                },
                                model: {
                                  value: _vm.newMediaType.TenantId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newMediaType, "TenantId", $$v)
                                  },
                                  expression: "newMediaType.TenantId",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.addNewType()
                            },
                          },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("done"),
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("Button.Save")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "secondary", outline: "" },
                          on: {
                            click: function ($event) {
                              return _vm.clearForm()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800px" },
          model: {
            value: _vm.showUpdateType,
            callback: function ($$v) {
              _vm.showUpdateType = $$v
            },
            expression: "showUpdateType",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("AdministrationMediaTypeManage.editTitleMsg")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      nativeOn: {
                        click: function ($event) {
                          _vm.showUpdateType = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "form2",
                  staticClass: "fullScreenWidth",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid2,
                    callback: function ($$v) {
                      _vm.valid2 = $$v
                    },
                    expression: "valid2",
                  },
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", "pa-3": "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Media Type Name",
                                  rules: _vm.editNameRules,
                                },
                                model: {
                                  value: _vm.editMediaType.Name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editMediaType, "Name", $$v)
                                  },
                                  expression: "editMediaType.Name",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: {
                                  label: "Icon Path",
                                  items: _vm.iconList,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "v-avatar",
                                          [
                                            _c("v-icon", [
                                              _vm._v(_vm._s(data.item)),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(data.item) +
                                            "\n                "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "v-list-tile-avatar",
                                          [
                                            _c("v-icon", [
                                              _vm._v(_vm._s(data.item)),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-list-tile-content", [
                                          _vm._v(_vm._s(data.item)),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                                model: {
                                  value: _vm.editMediaType.IconPath,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editMediaType, "IconPath", $$v)
                                  },
                                  expression: "editMediaType.IconPath",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-combobox", {
                                attrs: {
                                  label: "Tenant",
                                  items: _vm.allRoleList,
                                  "item-text": "RoleName",
                                  "item-value": "Id",
                                  rules: _vm.tenantRules,
                                  "return-object": "",
                                },
                                model: {
                                  value: _vm.editMediaType.Tenant,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editMediaType, "Tenant", $$v)
                                  },
                                  expression: "editMediaType.Tenant",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.updateMediaType()
                            },
                          },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("done"),
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("Button.Save")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "secondary", outline: "" },
                          on: {
                            click: function ($event) {
                              return _vm.clearForm()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("AppModal", {
        attrs: { "max-width": "800" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v(_vm._s(_vm.deleteDialogTitle))]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [_vm._v(_vm._s(_vm.deleteDialogText))]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "delete",
                      dark: "",
                      disabled: !_vm.isDeleteable,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.agreeDelete()
                      },
                    },
                  },
                  [
                    _c("v-icon", [_vm._v("delete_forever")]),
                    _vm._v(_vm._s(_vm.$t("Button.Remove")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "secondary", outline: "" },
                    on: {
                      click: function ($event) {
                        _vm.dialog = false
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.dialog,
          callback: function ($$v) {
            _vm.dialog = $$v
          },
          expression: "dialog",
        },
      }),
      _vm._v(" "),
      _c(
        "AppConfirmationModal",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.cannotRemove,
            callback: function ($$v) {
              _vm.cannotRemove = $$v
            },
            expression: "cannotRemove",
          },
        },
        [
          _c("template", { slot: "title" }, [
            _vm._v("\n      " + _vm._s(_vm.cannotDeleteDialogTitle) + "\n    "),
          ]),
          _vm._v(" "),
          _c("template", { slot: "text" }, [
            _vm._v("\n      " + _vm._s(_vm.cannotDeleteDialogText) + "\n    "),
          ]),
          _vm._v(" "),
          _c(
            "template",
            { slot: "actions" },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "secondary", outline: "" },
                  on: {
                    click: function ($event) {
                      _vm.cannotRemove = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-snackbar",
            {
              staticClass: "snackbarAdjust",
              attrs: { color: _vm.snackColor, timeout: null, top: "" },
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.snackMessage) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  nativeOn: {
                    click: function ($event) {
                      _vm.snackbar = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }